export default __webpack_public_path__ + "static/media/TokenKickRed.af873c5d.png";